
import ShoppingCart from '../../mixins/shopping-cart'

export default {
  name: 'CartItemQuantity',
  mixins: [ShoppingCart],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    width: {
      type: [String, Object],
      default: null
    },
    minimal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange(newValue, oldValue) {
      const quantity  = Math.abs(newValue - oldValue)
      const variantId = this.item.variantId

      if (newValue > oldValue) {
        this.addToCartWithCheck({ variantId, quantity })
      } else {
        this.removeFromCart({ variantId, quantity })
      }
    },
    onRemove() {
      if ((this.item.quantity - 1) > 0) {
        this.onChange(this.item.quantity - 1, this.item.quantity)
      }
    },
    onAdd() {
      this.onChange(this.item.quantity + 1, this.item.quantity)
    }
  }
}
